'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var HEADING_SIZES = exports.HEADING_SIZES = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1179/js/text/HeadingConstants.js
// module id = 363
// module chunks = 0